var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      staticStyle: {
        "border-radius": "4px !important",
        border: "1px solid #dee5ec",
        "margin-right": "12px",
      },
      attrs: {
        "class-name": "item-card",
        shadow: "never",
        "body-style": "margin: 8px;",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "flex flex-row",
          staticStyle: { margin: "8px 8px 8px 8px" },
        },
        [
          _c("div", { staticClass: "flex-1", staticStyle: { margin: "7px" } }, [
            _c("div", { staticClass: "flex flex-row" }, [
              _c(
                "div",
                {
                  staticClass: "item-name flex-1",
                  staticStyle: { "margin-top": "7px !important" },
                },
                [_vm._v("\n          USPS\n        ")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item-id" }, [
              _vm._v("\n        Track ID:   "),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://www.swiship.com/track/?id=" + _vm.trackingId,
                    target: "_blank",
                  },
                },
                [_vm._v(_vm._s(_vm.trackingId))]
              ),
              _vm._v(_vm._s() + "\n      "),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }